(function () {
  /**
   * @deprecated Please use src2/core/model/migration/migration.js
   *
   * @ngdoc factory
   * @name Migration
   * @description Model for an organization migration; can be used directly or subclassed for
   *   specific types of migration (e.g. T2EMigration) that have additional fields.
   */
  angular.module('binky.core.migration').factory('Migration', factory);

  /* @ngInject */
  function factory(_, binkySrc2, feature, MIGRATION_STATUS) {
    class Migration {
      /**
       * @description Creates a new Migration instance.
       *
       * @param {Object} rawData the raw migration JSON as returned by the backend
       * @param {MIGRATION_STATUS} rawData.status the current status of the migration
       * @param {MIGRATION_TYPE} rawData.type the migration type
       * @param {Object} [rawData.metadata] - optional additional fields
       * @param {String} [rawData.metadata.scheduledStartDate] - ISO8601 date, included for T2E migrations that have
       */
      constructor(rawData) {
        _.assignIn(this, _.pick(rawData, ['status', 'type', 'metadata']));
      }

      /**
       * @description Checks if the org is locked which by default is if this
       *  migration is currently migrating. Child classes should override this
       *  function if the logic to lock the org differs.
       *
       * @returns {Boolean} true if the org is locked.
       */
      isOrgLocked() {
        return this.status === MIGRATION_STATUS.MIGRATING;
      }

      /**
       * Parses the specified organization migration JSON into a Migration instance and returns it.
       * Intended to be used by the List service.
       *
       * @param {Object} rawData the raw migration JSON (see constructor docs)
       * @returns {Migration} the Migration instance representing the raw JSON
       */
      static apiResponseTransformer(rawData) {
        return new Migration(rawData);
      }

      // Disable rule as we can't use _.constant with JS class syntax
      // eslint-disable-next-line lodash/prefer-constant
      static canTransform() {
        // This class supports transforming any type of migration, so return true. Subclasses of
        // this class may parse migrations with a specific type.
        return true;
      }
    }

    return feature.isEnabled('temp_react_port_migrations')
      ? binkySrc2.models.migration.Migration
      : Migration;
  }
})();
